/** V3.0.1 immersive onboarding wizard steps (single `/onboarding` URL). */
export type OnboardingWizardStep =
  | "score-intro"
  | "value-prop"
  | "quiz/name"
  | "quiz/age"
  | "quiz/income"
  | "quiz/expenses"
  | "quiz/cash"
  | "quiz/debt"
  | "quiz/invest"
  | "quiz/risk"
  | "goal"
  | "loading"
  | "loading-error"
  | "fitness-score-result"
  | "result";

export type QuizProgressStep =
  | "quiz/name"
  | "quiz/age"
  | "quiz/income"
  | "quiz/expenses"
  | "quiz/cash"
  | "quiz/debt"
  | "quiz/invest"
  | "quiz/risk"
  | "goal";

export type GoalResultVariant =
  "million" | "home" | "runway" | "idle-cash" | "retirement" | "debt-free";

export type QuizAnswers = {
  name: string;
  age: string;
  income: number;
  expenses: number;
  cash: number;
  debt: number;
  invest: number;
  risk: string;
  goalId: string;
};

export const QUIZ_PROGRESS_STEPS: QuizProgressStep[] = [
  "quiz/name",
  "quiz/age",
  "quiz/income",
  "quiz/expenses",
  "quiz/cash",
  "quiz/debt",
  "quiz/invest",
  "quiz/risk",
  "goal",
];

export const WIZARD_STEP_ORDER: OnboardingWizardStep[] = [
  "score-intro",
  "value-prop",
  ...QUIZ_PROGRESS_STEPS,
  "loading",
  "fitness-score-result",
  "result",
];

export interface OnboardingWizardStepHandlers {
  step: OnboardingWizardStep;
  answers: QuizAnswers;
  quizProgressIndex: number;
  quizProgressTotal: number;
  resultVariant: GoalResultVariant;
  displayName: string;
  goNext: (answersOverride?: QuizAnswers) => void;
  goBack: () => void;
  setAnswer: <K extends keyof QuizAnswers>(
    key: K,
    value: QuizAnswers[K],
  ) => void;
  retryLoading: () => void;
  completeLoading: () => void;
  failLoading: () => void;
  simulateLoadingError: boolean;
}
